import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'

interface AmazonFeatureIntroCardProps {
  title: string | React.ReactNode
}

export const AmazonFeatureIntroCard = ({
  title,
}: AmazonFeatureIntroCardProps) => {
  return (
    <div className='group relative flex h-full min-h-[300px] flex-col items-center justify-center overflow-hidden rounded-lg bg-black p-6 text-white md:min-h-[400px]'>
      <div className='relative z-10 flex flex-col'>
        <div className='relative h-5 md:h-9'>
          <Image
            src={ImageHelper.getImageUrl(
              '/image/September2025/mceclip0_83.png'
            )}
            alt='Coolmate x Amazon'
            fill
            className='object-contain object-left'
          />
        </div>
        <p className='mt-6 max-w-xs text-center font-criteria text-xl font-semibold uppercase leading-normal md:text-xl 2xl:text-2xl'>
          {title}
        </p>
      </div>
      <Image
        src={ImageHelper.getImageUrl('/image/October2025/mceclip15.png')}
        alt='logo'
        fill
        className='absolute left-0 top-0 z-0 !h-auto object-contain object-left'
      />
    </div>
  )
}
